import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { EtiquetadoService } from "../../../services/etiquetado.service";
import { SpinnerService } from 'shared-components';
import { TranslateService } from '@ngx-translate/core';
@Component({
    selector: 'app-incidencias-consumos',
    templateUrl: './incidencias.component.html'
})
export class IncidenciasConsumoComponent implements OnInit {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;

    public incidencias = new Array<any>();

    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    public dropdownSection: number;
    public pestanaActiva = new Array<number>();

    @Input() consumoId;

    @Output() refresh = new EventEmitter<boolean>();

    constructor(
        private readonly _translate: TranslateService,
        private readonly _spinnerService: SpinnerService,
        private readonly _etiquetadoService: EtiquetadoService
    ) { }

    ngOnInit() {
        this.getIncidencias();
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    public getIncidencias() {
        let filters = {
            consumoId: this.consumoId
        };
        this._spinnerService.showSpinner();
        this._etiquetadoService.getIncidencias(filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.totalItems = resp.length;
            this.incidencias = resp.lista;
        });
    }

    public close() {
        this.refresh.emit();
    }

}
